import { Stack, Typography } from '@montugroup/design-system';
import { ClickAndCollectLoadingLocation } from './ClickAndCollectLoadingLocation';
import { ClickAndCollectPharmacyCard } from './ClickAndCollectPharmacyCard';
import { NoClickAndCollectCard } from './NoClickAndCollectCard';

export type ClickAndCollectCardItem = {
  id: number;
  name: string;
  address: string;
  distanceKm?: number;
  selected: boolean;
  hasInventory?: boolean;
};

type ClickAndCollectCardsProps = {
  isPending: boolean;
  hasLocations: boolean;
  cards: ClickAndCollectCardItem[];
  onSelect: (id: number) => void;
};

export function ClickAndCollectCards({ isPending, hasLocations, cards, onSelect }: ClickAndCollectCardsProps) {
  if (isPending && !hasLocations) {
    return <ClickAndCollectLoadingLocation data-testid="loading-location" />;
  }

  if (!hasLocations) {
    return <NoClickAndCollectCard data-testid="no-locations" />;
  }

  return (
    <>
      {cards.length > 1 && (
        <Typography variant="body1" marginBottom={3}>
          Select from one of the <strong>{cards.length}</strong> locations nearby
        </Typography>
      )}

      <Stack gap={2} marginBottom={2}>
        {cards.map((card) => (
          <ClickAndCollectPharmacyCard
            data-testid={`pharmacy-card-${card.id}`}
            key={card.id}
            id={card.id}
            name={card.name}
            address={card.address}
            distanceKm={card.distanceKm}
            selected={card.selected}
            hasInventory={card.hasInventory}
            onClick={() => onSelect(card.id)}
          />
        ))}
      </Stack>
    </>
  );
}
